import { Injectable } from '@angular/core';

import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';

import {
  Observable,
  finalize
} from 'rxjs';

import { LoadingService } from '../services/loading.service';


@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  constructor(
    private readonly loadingService: LoadingService
  ) { }


intercept(
  req: HttpRequest<any>,
  next: HttpHandler
): Observable<HttpEvent<any>> {

  console.log('INTERCEPTOR ÇALIŞTI:', req.url);

  this.loadingService.show();

  return next.handle(req).pipe(
    finalize(() => {

      console.log('REQUEST BİTTİ:', req.url);

      this.loadingService.hide();
    })
  );
}

}